import React from 'react'

const InputShadowOne = ({ name, value, placeholder, onChange, image  }) => {
    return (
        <div className='mt-3'>
            <div className="input-group rounded-pill shadow"> 
                <span 
                    className="bg-white border-0 rounded-pill" 
                    style={{ marginLeft:'1rem', paddingTop:'0.2rem'}}
                >
                    <img 
                        src={image} 
                        alt='image du logo' 
                        style={{ height:20, width:20, marginTop:'0.2rem' }} 
                    />
                </span>
                <input type="text" className='form-control border-0' value={value} name={name} onChange={onChange} placeholder={placeholder} />
                <span 
                    className="bg-white border-0 rounded-pill" 
                    style={{ marginRight:'1rem', paddingTop:'0.2rem', height:20, width:20 }}
                >
                </span>
            </div>
        </div>
    )
}

export default InputShadowOne